import { api } from '@services';

export interface IFilterRequest {
  modelNames?: string[];
  tagNames?: string[];
  statusId?: string[];
  usersId?: string[];
  manufactorNames?: string[];
  purchasedDateStart?: Date;
  purchasedDateEnd?: Date;
  sort?: string;
  direction?: 'ASC' | 'DESC' | undefined;
  removeFieldConfiguration?: boolean;
}
export interface IPagination {
  page: number;
  limit: number;
  search?: string;
}
interface IRequest {
  pagination?: IPagination;
  filter?: IFilterRequest;
}

const exportEquipmentsToCsv = async ({
  pagination,
  filter,
}: IRequest): Promise<string> => {
  let search = pagination?.search ? pagination.search : '';
  filter &&
    filter.manufactorNames &&
    filter.manufactorNames.forEach(
      // eslint-disable-next-line no-return-assign
      name =>
        (search = search.toLowerCase().replace(` ${name.toLowerCase()} `, '')),
    );
  const { data: url } = await api.get<string>(
    `/equipments?page=${pagination?.page || 1}&limit=${
      pagination?.limit || 20
    }&q=${search}${filter?.sort ? `&sort=${filter.sort}` : ''}${
      filter?.usersId ? `&usersId=${filter.usersId.join(',')}` : ''
    }${filter?.direction ? `&direction=${filter.direction}` : ''}${
      filter?.modelNames ? `&modelNames=${filter.modelNames.join(',')}` : ''
    }${
      filter?.manufactorNames
        ? `&manufactorNames=${filter.manufactorNames.join(',')}`
        : ''
    }${filter?.tagNames ? `&tagNames=${filter.tagNames.join(',')}` : ''}${
      filter?.statusId ? `&statusId=${filter.statusId.join(',')}` : ''
    }${
      filter?.purchasedDateStart
        ? `&purchasedDateStart=${new Date(filter.purchasedDateStart).toJSON()}`
        : ''
    }${
      filter?.purchasedDateEnd
        ? `&purchasedDateEnd=${new Date(filter.purchasedDateEnd).toJSON()}`
        : ''
    }${
      filter?.removeFieldConfiguration ? '' : '&useFieldConfiguration=true'
    }&getCsv=true`,
  );

  return url;
};

export { exportEquipmentsToCsv };
